export default function formatNumber(num, type) {
  if (type == "thousand") {
    var units = ["k", "M", "B", "T", "P", "E", "Z", "Y"];
    var decimal;

    num = parseFloat(num);

    for (var i = units.length - 1; i >= 0; i--) {
      decimal = Math.pow(1000, i + 1);

      if (num <= -decimal || num >= decimal) {
        const number = num / decimal;
        const formattedNumber = number.toFixed(2);

        return formattedNumber + units[i];
      }
    }

    return num.toFixed(2);
  } else if (type == "decimal") {
    const hasDecimal = num % 1 !== 0;

    return parseFloat(num).toLocaleString(
      undefined,
      hasDecimal
        ? {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        : {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
    );
  } else if (type == "range") {
    if (typeof num === "string" && num.includes("-")) {
      const [min, max] = num.split("-").map((p) => parseFloat(p).toFixed(2));
      return `${min} - ${max}`;
    } else {
      const hasDecimal = num % 1 !== 0;

      return parseFloat(num).toLocaleString(
        undefined,
        hasDecimal
          ? {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          : {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
      );
    }
  } else {
    return parseFloat(num).toFixed(2);
  }

  return num;
}
